
import Vue from 'vue';
import {Component, Emit, Prop} from 'vue-property-decorator';
import {
  ActionDefinition,
} from '../../backend/backendapi';

@Component({
  components: {
  },
})
export default class DefinitionEditorMqttSubscriberSpecific extends Vue {
  @Prop({required: true})
  definition!: ActionDefinition;
  @Prop({required: true})
  parsedJsonParameters!: any;

  
  get actionUrl(): string | null {
    return this.parsedJsonParameters.actionUrl ?? null;
  }

  set actionUrl(value: string | null) {
    this.parsedJsonParameters.actionUrl = value;
    this.onParsedJsonChanged();
  }

  get cellIdent(): string | null {
    return this.parsedJsonParameters.cellIdent ?? null;
  }

  set cellIdent(value: string | null) {
    this.parsedJsonParameters.cellIdent = value;
    this.onParsedJsonChanged();
  }

  get params(): string | null {
    return this.parsedJsonParameters.params ?? null;
  }

  set params(value: string | null) {
    this.parsedJsonParameters.params = value;
    this.onParsedJsonChanged();
  }
  
  canSaveChanged() {
    this.$nextTick(() => {
      let res = (this.actionUrl !== null) && (this.params !== null) && (this.cellIdent !== null);
      this.$emit("canSaveChanged", res);
    });
  }
  
  onParsedJsonChanged() {
    this.$emit('changed', this.parsedJsonParameters);
    this.canSaveChanged();
  }
}
